import React from 'react';
import { CircularProgress } from '@material-ui/core';
import moment from 'moment';


import { getComplianceSeconds, redToGreen } from '../../utils/CFuncs'
const colWidth = 60;
const colSpace = 10;

global.moment = moment;

function Column(props) {
  
  const secondsGoal = props.goal * 3600;
  const barHeight = 180;

  //const percentHeight = Math.round((barHeight * props.day.percent) / 100);
  let percentHeight = barHeight * (props.day.seconds / (24 * 3600));
  if (percentHeight >= barHeight) {
    percentHeight = barHeight;
  }
  const goalPercentHeight = barHeight * (props.goal / 24);
  const color = redToGreen(props.day.percent / 100.0);
  const graphStartY = 130;
  const day = moment(props.day.date);
  const isToday = day.isSame(moment(), 'd');
  const otherDayColor = '#AAA';
  const textColor = isToday ? 'black' : otherDayColor;
  const hourGoalDisp = secondsGoal / 3600;
  return (
    <g transform={`translate(${props.x},0)`}>
      <text
        x="25"
        y="35"
        textAnchor="middle"
        width={colWidth}
        fill={textColor}
        fontSize={20}
      >{day.toString().split(' ')[0].toUpperCase()}</text>
      <text
        x="19"
        y="60"
        width={colWidth}
        fill={textColor}
        fontSize={12}
      >{day.format('MMM')}</text>
      <text
        x="5"
        y="105"
        width={colWidth}
        fill={textColor}
        fontSize={40}
      >{day.format('DD')}</text>
      {percentHeight > goalPercentHeight ? (
        <React.Fragment>
          <rect
            height={percentHeight >= barHeight ? barHeight : percentHeight}
            width={colWidth}
            fill={'#3498db'}
            stroke={'#3498db'}
            x="0"
            y={graphStartY + (barHeight - (percentHeight >= barHeight ? barHeight : percentHeight))}
          />
          <rect
            height={goalPercentHeight}
            width={colWidth}
            fill={color}
            stroke={color}
            x="0"
            y={graphStartY + (barHeight - goalPercentHeight)}
          />
        </React.Fragment>
      ) : (
        <rect
          height={percentHeight >= barHeight ? barHeight : percentHeight}
          width={colWidth}
          fill={color}
          stroke={color}
          x="0"
          y={graphStartY + (barHeight - (percentHeight >= barHeight ? barHeight : percentHeight))}
        />
      )}
      <rect
        height={goalPercentHeight >= barHeight ? barHeight : goalPercentHeight}
        width={colWidth}
        fillOpacity={0}
        stroke={'#DDD'}
        x="0"
        y={graphStartY + (barHeight - (goalPercentHeight >= barHeight ? barHeight : goalPercentHeight))}
      />
      <rect
        height={barHeight}
        width={colWidth}
        stroke={textColor}
        fillOpacity={0}
        x="0"
        y={graphStartY}
      />
      <text
        x="0"
        y="350"
        width={colWidth}
        fill={textColor}
        textAnchor="start"
        fontSize={20}
      >
        {
          //MARKER
          `${Math.round(props.day.seconds /3600)} hrs` //props.day.percent was instead of props.seconds
        }
      </text>
    </g>
  )
}


function WeeklyChart(props) {

  const { min, physicalActivity, goal } = props;
  const secondsGoal = goal * 3600;
  if (physicalActivity.browseDailyPending) {
    return <CircularProgress color="primary" />;
  }

  const width = min;
  const height = Math.round(width * 0.75);

  let weekday;
  if (props.lastWeek) {
    weekday = moment().subtract(1, 'week');
  } else {
    weekday = moment();
  }

  const startOfWeek = weekday.clone().startOf('week');
  const endOfWeek = weekday.clone().endOf('week');
  let days = [];
  let day = startOfWeek;

  while (day <= endOfWeek) {
    days.push(day.toDate());
    day = day.clone().add(1, 'd');
  }


  days = days.map((d) => {
    const seconds = getComplianceSeconds(d, physicalActivity.browseDaily);
    return {
      date: d,
      seconds,
      percent: (secondsGoal !== 0)?Math.round((seconds / secondsGoal) * 100):0
    };
  });

  return (
    <svg width={width} height={height} viewBox="0 0 500 375">
      <rect
        x="0"
        y="0"
        width="500"
        height="375"
        stroke="#FFFFFF"
        strokeWidth="1"
        fill="#FFFFFF"
      />

      <Column
        x="10"
        day={days[0]}
        goal={goal}
      />
      <Column
        x={colWidth * 1 + colSpace * 2}
        day={days[1]}
        goal={goal}
      />
      <Column
        x={colWidth * 2 + colSpace * 3}
        day={days[2]}
        goal={goal}
      />
      <Column
        x={colWidth * 3 + colSpace * 4}
        day={days[3]}
        goal={goal}
      />
      <Column
        x={colWidth * 4 + colSpace * 5}
        day={days[4]}
        goal={goal}
      />
      <Column
        x={colWidth * 5 + colSpace * 6}
        day={days[5]}
        goal={goal}
      />
      <Column
        x={colWidth * 6 + colSpace * 7}
        day={days[6]}
        goal={goal}
      />
    </svg>
  );

}

export default WeeklyChart
